import Button from "components/ui/button/Button";
import Modal from "components/ui/modal/Modal";
import toast from "components/ui/toast/Toast";
import { useDeleteBidResponses } from "lib/hooks/api/bid/bid_responses/useDeleteBidResponses";
import { pluralise } from "lib/utils";
import { Flex, Text } from "../../../../styles/utility-components";

type Props = {
  isOpen: boolean;
  ids: string[];
  onOpenChange: (open: boolean) => void;
};

export default function DeleteBidResponsesModal({ isOpen, ids, onOpenChange }: Props) {
  const { mutate: deleteBidResponses, isPending } = useDeleteBidResponses({
    onSuccess: (data) => {
      const deletedBidResponses = data.deleteBidResponses;

      toast.success(
        `${pluralise(deletedBidResponses.length, "response")} bid deleted successfully`,
      );

      onOpenChange(false);
    },

    onError: (err, variables) => {
      console.error("Failed to delete bid response:", err);
      toast.error(`Failed to delete bid ${pluralise(variables.ids.length, "response")}`);
    },
  });
  return (
    <Modal
      open={isOpen}
      showCloseButton={false}
      onOpenChange={onOpenChange}
      padding={32}
      maxWidth="440px"
    >
      <Flex flexDirection="column" gap={16} aria-label="Delete bid response modal">
        <Flex flexDirection="column" gap={8}>
          <Text bold>Delete bid response{ids.length > 1 ? "s" : ""}</Text>
          <Text>
            Are you sure you want to delete {ids.length > 1 ? "these" : "this"} bid response
            {ids.length > 1 ? "s" : ""}? This action cannot be undone.
          </Text>
        </Flex>
        <Flex gap={8} alignSelf="flex-end">
          <Button buttonType="secondary" disabled={isPending} onClick={() => onOpenChange(false)}>
            Cancel
          </Button>
          <Button
            buttonStyle="destructive"
            loading={isPending}
            onClick={() => {
              if (ids.length === 0) return;
              deleteBidResponses({ ids });
            }}
          >
            Delete
          </Button>
        </Flex>
      </Flex>
    </Modal>
  );
}
